<script lang="ts">
    
    import type { GameType } from "../../global";

    export let type: GameType;

    const typesMap: Record<GameType, string> = {
        'Bingo90'               : 'Binfun 90',
        'Bingo75'               : 'Binfun 75',
        'BingoMex'              : 'Lotería mexicana',
        'BingoAnimals'          : 'Binfun animales',
        'BingoCartoon'          : 'Binfun caricaturas',
        'Movies'                : 'Binfun películas',
        'MoviesKids'            : 'Binfun películas kids',
        'XMas'                  : 'X-Mas',
        'Football'              : 'Football',
        'Halloween'             : 'Halloween',
        'Superheroes'           : 'Superheroes',
        'Cartoon'               : 'Binfun Cartoon'
    };

    $: text = typesMap[type];

</script>

<slot {text}>{text}</slot>
